import { WizBehaviorDirectiveModule } from './../../../directives/behavior/wiz-behavior-directives.module';
import { WizItemRendererModule } from './../../../interfaces/wiz-item-renderer';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizTree } from './wiz-tree';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { WizLabelModule } from '../wiz-label/wiz-label.module';
import { WizStylingDirectiveModule } from '../../../directives/styling/wiz-styling-directives.module';
import { WizLayoutModule } from '../../layouts/wiz-layout.module';
import { CdkTreeModule } from '@angular/cdk/tree';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BrowserModule } from '@angular/platform-browser';
import { CollectionModule } from '../../../services/collections/collection.module';
import { WizButtonModule } from '../button/wiz-button.module';

@NgModule({
  declarations: [WizTree],
  imports: [
    CommonModule,
    MatTreeModule,
    CdkTreeModule,
    MatIconModule,
    WizButtonModule,
    WizLabelModule,
    WizStylingDirectiveModule,
    WizLayoutModule,
    ScrollingModule,
    BrowserModule,
    WizItemRendererModule,
    CollectionModule,
    WizBehaviorDirectiveModule,
  ],
  exports: [WizTree],
})
export class WizTreeModule {}
